import React, { useState } from 'react';
import { Modal } from '@material-ui/core';

import { logisticsApi } from 'api/logistics';
import { FormComponent } from 'shared';

const CARRIER_VARIANTS = {
    ups_air: 'ups',
    fedex_express: 'fedex',
};

const EASYPOST_CARRIERS = [
    'fedex',
    'ups',
    'ontrac',
    'lasership',
    'courierexpress',
    'uds',
    'columbuslastmile',
    'fedex_express',
    'ups_air',
];

function isCompatibleCarrier(lineHaulCarrier, epAccountCarrier) {
    return lineHaulCarrier === epAccountCarrier || CARRIER_VARIANTS[lineHaulCarrier] === epAccountCarrier;
}

function isEasypostCarrier(carrier) {
    return EASYPOST_CARRIERS.includes(carrier);
}

function EditCarrierModal({ carriers, closeModal, epOpts, rowData }) {
    const [error, setError] = useState(null);

    const compatibleEpAccountNames = (carrier) =>
        epOpts.filter((item) => isCompatibleCarrier(carrier, item.carrier)).map((item) => item.name);

    const formFields = [
        {
            name: 'lineHaulID',
            initialValue: rowData.id,
            inputElement: 'textField',
            label: 'Line Haul ID',
            gridValue: 4,
            inputProps: { readOnly: true },
        },
        {
            name: 'carrier',
            initialValue: rowData.carrier,
            inputElement: 'select',
            label: 'Carrier',
            gridValue: 4,
            inputProps: {
                required: true,
                opts: carriers,
            },
        },
        {
            name: 'easypostCarrierAccountName',
            initialValue: rowData.easypostCarrierAccountName || '',
            inputElement: 'select',
            label: 'Easypost Account',
            gridValue: 4,
            inputProps: {
                opts: (formData) => compatibleEpAccountNames(formData.carrier || rowData.carrier),
            },
        },
    ];

    return (
        <Modal open onClose={closeModal}>
            <div style={{ outline: 0, backgroundColor: 'white', width: '700px', margin: '10% auto', padding: '10px' }}>
                <h3>Edit Line Haul Carrier</h3>
                <FormComponent
                    formFields={formFields}
                    onSubmit={async (formData) => {
                        const { carrier } = formData;
                        if (!carrier) {
                            setError('Carrier is required');
                            return;
                        }

                        const compatibleAccounts = compatibleEpAccountNames(carrier);
                        let { easypostCarrierAccountName } = formData;
                        easypostCarrierAccountName = easypostCarrierAccountName || null;
                        if (easypostCarrierAccountName && !compatibleAccounts.includes(easypostCarrierAccountName)) {
                            easypostCarrierAccountName = null;
                        }

                        if (isEasypostCarrier(carrier) && !easypostCarrierAccountName) {
                            setError('Easypost Account is required for EasyPost carriers');
                            return;
                        }

                        const response = await logisticsApi.updateLineHaulCarrier(formData.lineHaulID, {
                            carrier,
                            easypostCarrierAccountName,
                        });
                        if (response.status === false) {
                            let message = 'Error modifying line haul carrier';
                            if (response?.msg) {
                                message += `: ${response.msg}`;
                            }
                            setError(message);
                        } else {
                            closeModal();
                        }
                    }}
                />
                {error && <div style={{ color: 'red' }}>{error}</div>}
            </div>
        </Modal>
    );
}

export { EditCarrierModal, isCompatibleCarrier };
